<div class="modal-body">
  <div class="modal-header">
    <div class="user-icon-title-container">
      <span class="lato-18-n-vw message">
      </span>
    </div>
    <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="closeModal()">
    </div>
  </div>
  <div class='modal-content-body'>
    <div class="main-container">
      <div class="header-main-area"
        [ngStyle]="{'padding-right': questions.length >= 5 ? '.8vw' : ''}">
        <div class="ese-main-heading lato-18-n-vw"><span class="blue-text">CREATE EMERGING SECURITY
            EVENT (ESE)</span> | BUILD DEFAULT QUESTIONNAIRE</div>
        <cygov-button class="button-margin" [buttonText]="'Create from Template'"
          [buttonWidth]="'10vw'" [buttonHeight]="'4vh'" [textSize]="'16'" [buttonColor]="'#29a9eb'"
          [hoverColor]="'#0F92E3'" *ngIf="isFromVendorListing" (click)="openESEAcknowledgementModal(this.eseacknowledgementHeader,eseTemplateContent,eseTemplateFooter,ESEModalEnum.QUESTIONNAIRE
          )">
        </cygov-button>

      </div>

      <cygov-emerging-security-event-action-buttons [isFromVendorListing]="isFromVendorListing"
        [isEditMode]="isEditMode" (upload)="onUpload($event)" (download)="onDownload()"
        (save)="onSave()" (delete)="onDelete()" (enableEdit)="enableEdit($event)"
        [questions]="questions" [disableDelete]="disableDelete"
        (saveButtonClicked)="notifySaveButtonClicked()"></cygov-emerging-security-event-action-buttons>

      <cygov-emerging-security-event-table #emergingSecurityEventTable [data]="questions"
        [selectedData]="selectedQuestion" [isEditMode]="isEditMode" (addData)="addQuestion()"
        (updateData)="updateQuestion($event)" (setSelectedRow)="setSelectedRow($event)"
        [isFromVendorListing]="isFromVendorListing" class="ese-table"
        [initialErrorObject]="initialErrorObject" [keysObject]="keysObject"
        [validationErrors]="validationErrors" [headerItemsESE]="headerItemsESE"
        [isLoading]="isLoading" (onUploadArtifact)="onUploadArtifact($event)"
        (removeArtifact)="removeArtifact($event)"
        [failedRows]="failedRows"></cygov-emerging-security-event-table>

      <div class="failled-rows-container" *ngIf="failedRows.length"
        [ngClass]="{'failed-rows-container-vendor-listing': isFromVendorListing}">
        <div class="lato-14-n-vw failed-row-title "><b class="lato-16-l-vw asterisk">*</b>One or
          more
          questions are incomplete.
          Please
          review and fill in
          the
          missing details before continuing. (Incomplete question(s): {{formattedFailedRows}})</div>
      </div>
    </div>
    <div class="horizontal-seprator"></div>
    <div class="modal-content-footer">
      <cygov-button class="button-margin" [buttonText]="'COMPLETE'" [buttonWidth]="'5vw'"
        [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'"
        (click)="!isEditMode && checkEventNameAndDueDate() && onComplete()"
        [disableClick]="isEditMode || !checkEventNameAndDueDate() || isProcessing"
        [fullyDisabled]="isEditMode||  !checkEventNameAndDueDate() || isProcessing">
      </cygov-button>
    </div>

  </div>
</div>

<ng-template #eseAcknowledgementHeader>
  <!-- Empty for filters -->
</ng-template>

<ng-template #eseAcknowledgementContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <div class="tick-icon-container">
      <div class="tick-icon" cygovSvgIcon [svgName]="'complete-popup'"></div>
    </div>
    <span class='lato-22-n-vw text-white text-center'>The Emerging Security Event Template <br> has
      been
      successfully created.
    </span>
  </div>
</ng-template>
<ng-template #eseAcknowledgementFooter>
  <div class='external-scan-request-acknowledgement-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'OK'" [buttonWidth]="'6.6vw'" [textSize]="'14'"
      [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'" [buttonHeight]="'2.963vh'"
      (click)="closeModal(true)"></cygov-button>

  </div>
</ng-template>
<ng-template #eseTemplateContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <span class='lato-20-n-vw text-white text-center'>Please note, you are about to create a <br>
      new
      questionnaire from a template, which will <br> override and erase the existing one.
    </span>
  </div>
</ng-template>

<ng-template #eseTemplateFooter>
  <div class='external-scan-request-acknowledgement-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'CONFIRM'" [buttonWidth]="'5vw'"
      [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      [buttonHeight]="'2.963vh'" (click)="openCreatFromTemplateModal()"></cygov-button>
    <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
      [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
      (click)="closeModal(true)">
    </cygov-button>
  </div>
</ng-template>

<ng-template #eseCreateFromTemaplteAcknowledgementContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <div class="tick-icon-container">
      <div class="tick-icon" cygovSvgIcon [svgName]="'complete-popup'"></div>
    </div>
    <span class='lato-22-n-vw text-white text-center'>The Emerging Security Event {{eventName}}
      <br>
      has been successfully created and sent to <span>{{this.selectedVendorName}}</span>

    </span>
  </div>
</ng-template>